"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryCodes = exports.GeoaggloHighlight = exports.Geoagglo = void 0;
const countryCodes = exports.countryCodes = ['france', 'espagne', 'suisse'];
class Geoagglo {
  constructor(id, code, areaId, bounds, center, name, logo, institutionalLogo, photo, hasBSS, importance) {
    this.id = id;
    this.code = code;
    this.areaId = areaId;
    this.bounds = bounds;
    this.center = center;
    this.name = name;
    this.logo = logo;
    this.institutionalLogo = institutionalLogo;
    this.photo = photo;
    this.hasBSS = hasBSS;
    this.importance = importance;
  }
}
exports.Geoagglo = Geoagglo;
class GeoaggloHighlight {
  constructor(id, title, description, photo, url, external = true, rideId = null, bikeRouteId = null, poiId = null) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.photo = photo;
    this.url = url;
    this.external = external;
    this.rideId = rideId;
    this.bikeRouteId = bikeRouteId;
    this.poiId = poiId;
  }
}
exports.GeoaggloHighlight = GeoaggloHighlight;